export default __webpack_public_path__ + "static/media/DanskeHuman-MediumItalic.77eddb54.woff";